export const WelcomeBanner = () => (
  <s-banner heading="¡Bienvenido a CodWay!" tone="info" dismissible>
    Gracias por unirte a la aplicación CodWay! Estamos encantados de tenerte a
    bordo.
    <br />
    <br />
    Queremos hacer que tu experiencia con nosotros sea lo más fluida y
    productiva posible. Como parte de este compromiso, nos gustaría informarte
    que hemos guardado tu dirección de correo electrónico en nuestra base de
    datos. Este paso es esencial por algunas razones: Seguridad de la cuenta,
    Comunicación, Soporte personalizado.
  </s-banner>
);
